import * as $   from "jquery";
import type { RandProductsResponse } from './types';
import { Promotions } from "Components/Promotions";
import { formatCurrency } from "Core/Currencies";
import { getCurrentLanguage } from "Core/Languages";

export const AddCartModal = (() => {

        const Selector = {
                MODAL:                  '#cart-modal',
                ADD_TO_CART_BTN:	'.js_product_page_add_to_cart',
                ADD_TO_CART_CATEGORY_BTN: '.js_category_page_add_to_cart',
                BASKET_PRODUCT_NAME: '#bskPrdName',
                PROMOTIONS: '.promotions'
        }

        interface InitCartModalArgs {
                productName: string;
                productId: string;
                basketType: string;
        }
        async function init({
                productName,
                productId,
                basketType
        }: InitCartModalArgs) {                
                $(Selector.BASKET_PRODUCT_NAME).html(productName);
                const { status, data } = await getData(productId);

                if (status === 'success') {
                        toggleVisibilityPromotionsOnCartModal(basketType);
                        showModalWithData(data);

                        if (data.cartThreshold && basketType !== "mod_bsk_offer") {
                                Promotions.updateValues({
                                        currentThresholdMin: data.cartThreshold.currentThreshold,
                                        currentThresholdMax: data.cartThreshold.nextGreatestThreshold,
                                        remainingAmount: data.cartThreshold.missingAmount,
                                        currentCartAmount: data.cartThreshold.currentBasketAmount,
                                        currentThresholdPercent: data.cartThreshold.currentPercent,
                                        nextThresholdPercent: data.cartThreshold.nextGreatestPercent,
                                        lastThresholdPercent: data.cartThreshold.lastPercent
                                });
                        }
                }
        }
        
        async function getData(productId: string): Promise<{ status: 'success' | 'failed', data: RandProductsResponse }> {
                const url = `/${getCurrentLanguage}/rand_products/rand/${productId}/`;
                const response = await fetch(url);
                const data: RandProductsResponse = await response.json();

                if (response.ok) {
                        return {
                                status: 'success',
                                data: data
                        }
                } else {
                        return {
                                status: 'failed',
                                data: undefined
                        }
                }
        }

        function showModalWithData(data: RandProductsResponse){
                let salesProducts = data.salesProducts;
                if(salesProducts.length > 0){
                        makeTile(salesProducts);
                        $(Selector.MODAL).modal('show')
                }
        }

        function makeTile(data: RandProductsResponse['salesProducts']) {
                for(let i=0; i < data.length; i++) {
                        const target = $(Selector.MODAL).find(`#tile${i}`);
                        const name = data[i].produkt_nazwa;
                        const image = data[i].produkt_nazwa_pliku_grafiki;
                        const address = `/${data[i].lang}${data[i].object_link}`;

                        $(target).removeClass('d-none')
                        $(target).find('a').attr('href', address).attr('alt', name);
                        $(target).find('.js_name_container').text(name);
                        image != null ?
                                $(target).find('.js_product_image').attr('src', `/web/gfx-base/s_1/gfx/products/midi/${image}`).attr('alt', name) :
                                $(target).find('.js_product_image').attr('src', '/public/build/assets/images/product_default.jpg').attr('alt', name);
                }


        }

        function toggleVisibilityPromotionsOnCartModal(basketType: string)
        {
                if(basketType === "mod_bsk_offer"){
                        $(Selector.PROMOTIONS).css("display", "none");
                }else{
                        $(Selector.PROMOTIONS).css("display", "block");
                }
        }

        return {
                init
        }
})();

import * as $   from "jquery";
import type { RandProductsResponse } from './types';
import { Promotions } from "Components/Promotions";
import { formatCurrency } from "Core/Currencies";
import { getCurrentLanguage } from "Core/Languages";

export const AddCartModal = (() => {

        const Selector = {
                MODAL:                  '#cart-modal',
                ADD_TO_CART_BTN:	'.js_product_page_add_to_cart',
                ADD_TO_CART_CATEGORY_BTN: '.js_category_page_add_to_cart',
                BASKET_PRODUCT_NAME: '#bskPrdName',
                PROMOTIONS: '.promotions'
        }

        interface InitCartModalArgs {
                productName: string;
                productId: string;
                basketType: string;
        }
        async function init({
                productName,
                productId,
                basketType
        }: InitCartModalArgs) {                
                $(Selector.BASKET_PRODUCT_NAME).html(productName);
                const { status, data } = await getData(productId);

                if (status === 'success') {
                        toggleVisibilityPromotionsOnCartModal(basketType);
                        showModalWithData(data);

                        if (data.cartThreshold && basketType !== "mod_bsk_offer") {
                                Promotions.updateValues({
                                        currentThresholdMin: data.cartThreshold.currentThreshold,
                                        currentThresholdMax: data.cartThreshold.nextGreatestThreshold,
                                        remainingAmount: data.cartThreshold.missingAmount,
                                        currentCartAmount: data.cartThreshold.currentBasketAmount,
                                        currentThresholdPercent: data.cartThreshold.currentPercent,
                                        nextThresholdPercent: data.cartThreshold.nextGreatestPercent,
                                        lastThresholdPercent: data.cartThreshold.lastPercent
                                });
                        }
                }
        }
        
        async function getData(productId: string): Promise<{ status: 'success' | 'failed', data: RandProductsResponse }> {
                const url = `/${getCurrentLanguage}/rand_products/rand/${productId}/`;
                const response = await fetch(url);
                const data: RandProductsResponse = await response.json();

                if (response.ok) {
                        return {
                                status: 'success',
                                data: data
                        }
                } else {
                        return {
                                status: 'failed',
                                data: undefined
                        }
                }
        }

        function showModalWithData(data: RandProductsResponse){
                let salesProducts = data.salesProducts;
                if(salesProducts.length > 0){
                        makeTile(salesProducts);
                        $(Selector.MODAL).modal('show')
                }
        }

        function makeTile(data: RandProductsResponse['salesProducts']) {
                for(let i=0; i < data.length; i++) {
                        const target = $(Selector.MODAL).find(`#tile${i}`);
                        const name = data[i].produkt_nazwa;
                        const image = data[i].produkt_nazwa_pliku_grafiki;
                        const address = `/${data[i].lang}${data[i].object_link}`;

                        $(target).removeClass('d-none')
                        $(target).find('a').attr('href', address).attr('alt', name);
                        $(target).find('.js_name_container').text(name);
                        image != null ?
                                $(target).find('.js_product_image').attr('src', `/web/gfx-base/s_1/gfx/products/midi/${image}`).attr('alt', name) :
                                $(target).find('.js_product_image').attr('src', '/public/build/assets/images/product_default.jpg').attr('alt', name);
                }


        }

        function toggleVisibilityPromotionsOnCartModal(basketType: string)
        {
                if(basketType === "mod_bsk_offer"){
                        $(Selector.PROMOTIONS).css("display", "none");
                }else{
                        $(Selector.PROMOTIONS).css("display", "block");
                }
        }

        return {
                init
        }
})();

